module.exports = __webpack_public_path__ + "img/anatomy-for-sculptors-detailed-shapes-of-the-male-neck-triangles-anatomy-for-sculptors-full.190fc463.jpg";